"use client";
import React from "react";
import Image from "@components/common/Image";

import { useStrapiContext } from "@providers/StrapiProvider";
import { usePageContext } from "@providers/PageProvider";
import getter from "@services/StrapiService/getter";
import styles from "./Details.module.scss";
import cx from "classnames";
import { get, map } from "lodash";

import TableContentRight from "@components/common/TableContentRight";
import TableContent from "@components/common/TableContent";

const View = () => {
  const { pageData } = usePageContext();
  const { str } = useStrapiContext();
  const details = getter.details(pageData);
  const image: any = getter.image(get(pageData, "attributes.image"));
  return (
    <>
      <div className={cx(styles.section)}>
        {/* <div className="inner-content pb-[1rem] mb-0">
        <h1 className={styles.title}>{getter.title(pageData)}</h1>
        <Author {...{ ...author, createdAt }} />
        <p className={styles.description}>{getter.description(pageData)}</p>
      </div> */}
        <div className={cx("inner-content-left", styles.left)}>
          <div className={styles.tableContent}>
            <TableContent data={details} />
          </div>
          <div className="">
            {image?.src === "" ? (
              <div className={styles.imageBg}>
                <span className={styles.title}>{getter.title(pageData)}</span>
              </div>
            ) : (
              <Image
                {...getter.image(get(pageData, "attributes.image"))}
                wrapperProps={{ className: styles.image }}
                scale="1.02"
                speed="-0.4"
              />
            )}
          </div>
          <div className="mt-[2rem]">{str.renderComp(details)}</div>
        </div>
        <div
          id="fixed-elements"
          className={cx("inner-content-right", styles.right)}
        >
          <div
            data-scroll
            data-scroll-sticky
            data-scroll-target="#fixed-elements"
            data-scroll-offset="-84"
          >
            <TableContentRight data={details} />
          </div>
          {/* TODO More */}
        </div>
      </div>
    </>
  );
};
export default View;
